import type { PageContext } from '@zto/zpage'
import dayjs from 'dayjs'

// 新增、编辑、详情
export function addEditDialog(type: string) {
  const isAdd = type === 'add' // 新增
  const isView = type === 'view' // 详情

  const actions = isView
    ? {
        close: {}
      }
    : {
        close: {},
        submit: { label: '确定' }
      }

  return {
    width: 500,
    labelWidth: 100,
    itemSpan: 24,

    formItems: [
      {
        type: 'text',
        label: '供应商ID',
        prop: 'supplierCode',
        visibleOn: `${!isAdd}`
      },
      {
        type: 'input',
        label: '供应商名称',
        prop: 'supplierName',
        maxlength: 30,
        trim: true,
        disabled: isView,
        required: true
      },
      {
        type: 'input',
        label: '企业联系人',
        prop: 'contactName',
        maxlength: 30,
        trim: true,
        disabled: isView,
        required: true
      },
      {
        type: 'input',
        label: '联系人手机号',
        prop: 'contactPhone',
        maxlength: 11,
        trim: true,
        rules: [
          {
            required: true,
            pattern: /^1[3-9][0-9]\d{8}$/,
            message: '请填写正确的手机号码'
          }
        ],
        disabled: isView,
        required: true
      }
    ],

    beforeSubmit: async ({ app, data }: PageContext, model: any, options: any) => {
      if (data.creator) delete data.creator
      if (data.gmtCreate) delete data.gmtCreate

      return true
    },

    actions
  }
}

// 日志对话框
export const logDialog = {
  width: 600,
  top: '10vh',
  labelWidth: 0,
  itemSpan: 24,

  onShow: async ({ app, data }: PageContext) => {
    const res = await app.request({
      api: '/cabinet/admin/base/AdminBaseCommonQueryController/queryAuditLogPage',
      params: { bizNo: data.supplierCode, logScene: 'base.supplier_operate', current: 1, size: 100 }
    })
    return {
      payload: {
        operateLogData: res.data
      }
    }
  },

  formItems: [
    {
      label: '',
      labelWidth: 0,
      type: 'edit-table',
      prop: 'operateLogData',
      span: 24,
      noOperation: true,
      autoHeight: true,
      border: true,
      columns: [
        {
          label: '操作时间',
          minWidth: 150,
          formatter: (row: any) => {
            return row.gmtCreate ? dayjs(row.gmtCreate).format('YYYY-MM-DD HH:mm:ss') : '--'
          }
        },
        { prop: 'logDesc', label: '操作名称', minWidth: 160 },
        { prop: 'creator', label: '操作人', minWidth: 100 }
      ]
    }
  ],

  actions: {
    close: {}
  }
}
